// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import React from "react";
import { AiOutlineDollar } from "react-icons/ai";
import PrimaryButton from "./PrimaryButton";
import { ActionPrevProps } from "../types/common";

const TopUp: React.FC<ActionPrevProps> = ({showPrev}) => {
  return (
    <>
      <div>
      <div className="relative mt-2 rounded-xl">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <span className="text-gray-500 sm:text-sm">$</span>
        </div>
        <input
          id="price"
          name="price"
          type="number"
          placeholder="0.00"
          aria-describedby="price-currency"
          className="input-number"
          />
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          <span id="price-currency" className="text-gray-500 sm:text-sm">
            USD
          </span>
        </div>
      </div>
      </div>
      <div className="flex items-center gap-2 mt-4 mb-8">
        <div className="bg-white rounded-3xl px-3 py-2">
          <div className="flex items-center gap-1.5">
            <AiOutlineDollar className="w-4 h-4 text-[#9392A2]" />
            <p className="text-[#0F0C18] text-sm font-medium tracking-tight">$ 20</p>
          </div>
        </div>
        <div className="bg-white rounded-3xl px-3 py-2">
          <div className="flex items-center gap-1.5">
            <AiOutlineDollar className="w-4 h-4 text-[#9392A2]" />
            <p className="text-[#0F0C18] text-sm font-medium tracking-tight">$ 50</p>
          </div>
        </div>
        <div className="bg-white rounded-3xl px-3 py-2">
          <div className="flex items-center gap-1.5">
            <AiOutlineDollar className="w-4 h-4 text-[#9392A2]" />
            <p className="text-[#0F0C18] text-sm font-medium tracking-tight">$ 100</p>
          </div>
        </div>
        <div className="bg-white rounded-3xl px-3 py-2">
          <div className="flex items-center gap-1.5">
            <AiOutlineDollar className="w-4 h-4 text-[#9392A2]" />
            <p className="text-[#0F0C18] text-sm font-medium tracking-tight">$ 200</p>
          </div>
        </div>
      </div>
      <hr />
      <div className="flex items-center gap-2">
        <PrimaryButton onClick={() => showPrev && showPrev()} className="w-full py-2.5 rounded-3xl" label="Back" black />
        <PrimaryButton className="w-full py-2.5 rounded-3xl" label="Pay" />
      </div>
    </>
  );
};

export default TopUp;